










































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class IdrBiduiPreviewBiaoqian extends Vue {
  @Prop()
  private message: any;
}
